module.exports = __webpack_public_path__ + "static/media/delet.9affa24b.svg";